
import { Point } from 'pixi.js';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import { Ease } from '../../../vendor_core/core/src/Ease';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import IAdvanceGeneralGameConfig from '../../../vendor_core/core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import { IWinData } from '../../../vendor_core/core/src/server/data/ISpinData';
import { Timeline } from '../../../vendor_core/core/src/Timeline';
import { Tween } from '../../../vendor_core/core/src/Tween';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import { BitmapMoneyField } from '../../../vendor_core/core/src/views/BitmapMoneyField';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import IVendorClientConfigRequestData from '../../../vendor_core/src/server/requests/contracts/IVendorClientConfigRequestData';
import VendorWinlinesView from '../../../vendor_core/src/view/VendorWinlinesView';
import GameSoundVars from '../enums/GameSoundVars';

export default class CRCWinlinesView extends VendorWinlinesView {
    // Check jurisdiction if we should play ante win animation and sound
    private disableLowWinCelebration = ConfigManager.getConfig<IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>>(ConfigurationTypes.GAME).clientConfig.disableLowWinCelebration;

    public highlightWinLine(winLineData: IWinData, removePrevious = true): void {
        if (removePrevious) {
            this.winFrameContainer.removeChildren();
        }

        const cfg = {
            symWidth: Layout.scalePixels(this.symBounds.width),
            symHeight: Layout.scalePixels(this.symBounds.height),
            reelGap: Layout.scalePixels(GameModel.gameConfig.reelGap),
            symGap: Layout.scalePixels(GameModel.gameConfig.symGap),
            frameLeft: Layout.scalePixels(GameModel.gameConfig.frameLeft),
            frameTop: Layout.scalePixels(GameModel.gameConfig.frameTop),
            frameBottom: Layout.scalePixels(GameModel.gameConfig.frameBottom),
            frameRight: Layout.scalePixels(GameModel.gameConfig.frameRight),
            beginningOffset: Layout.scalePixels(
                GameModel.gameConfig.beginningOffset
            ),
            winFrameConnectors: GameModel.gameConfig.winFrameConnectors,
            frameConnectorVerticalOffset: Layout.scalePixels(
                GameModel.gameConfig.frameConnectorVerticalOffset
            ),
        };

        if (winLineData.normalLineWin) {
            const lineId = winLineData.lineId;
            const lineSymPositions =
                GameModel.serverGameConfig.paylines[lineId];
            const numWinSyms = winLineData.winSymbols.length;
            const numLineSyms = lineSymPositions.length;

            if (
                GameModel.gameConfig.noWinFrame ||
                (numWinSyms < numLineSyms && this.config.winLineTails)
            ) {

                //HEAD
                let startPt = new Point();
                let endPt = new Point();
                startPt.x = cfg.beginningOffset;
                endPt.x = startPt.x + (cfg.reelGap + cfg.symWidth * 0.5);
                startPt.y =
                    lineSymPositions[0] *
                    (cfg.symHeight + cfg.symGap) +
                    cfg.symHeight * 0.5;
                endPt.y = startPt.y;

                this.drawLineSegment(startPt, endPt, true);

                let chainedEndpoint = endPt;

                let position = GameModel.gameConfig.noWinFrame
                    ? 0
                    : numWinSyms - 1;
                let endPosition = position + 1;

                //BODY
                while (position < numLineSyms - 1) {
                    startPt.x = chainedEndpoint.x;

                    endPt.x =
                        cfg.beginningOffset +
                        (endPosition * (cfg.symWidth + cfg.reelGap) +
                            cfg.symWidth * 0.5);

                    startPt.y = chainedEndpoint.y;

                    endPt.y =
                        lineSymPositions[endPosition] *
                        (cfg.symHeight + cfg.symGap) +
                        cfg.symHeight * 0.5;

                    this.drawLineSegment(startPt, endPt, true);

                    chainedEndpoint = endPt;

                    position++;
                    endPosition++;
                }

                // TAIL
                startPt = new Point();
                endPt = new Point();
                startPt = chainedEndpoint;
                endPt.x = startPt.x + (cfg.reelGap + cfg.symWidth * 0.5) + cfg.beginningOffset;
                endPt.y = startPt.y;

                this.drawLineSegment(startPt, endPt, false);
            };
        };
    };

    public setWinBannerValue(value: number, animate = false): void {
        this.playWinSound();
        Tween.delayedCall(1.3, () => {
            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
        })
    }

    public playWinSound(): void {
        if(this.disableLowWinCelebration){
            return;
        }

        SoundController.fadeStop("win_loop", 0.5);

        if (!this.winValueBannerBangUp.currentBangup) {
            // The same as what the reel group would do.
            SoundController.playSound(SoundVars[SpinModel.getWinsoundName()]);
            ReelGroup.instance?.on(
                GameEvents.ALL_REELS_STARTED,
                () => {
                    SoundController.fadeStop(SoundVars[SpinModel.getWinsoundName()], 0.5);
                    SoundController.fadeStop("win_loop", 0.5);
                },
                this);
        } else {
            /// super.playWinSound();
            if (this.winThresholds) {
                let winSound: string = this.winThresholds[0].name;

                const profit = Math.round(SpinModel.getAccumulatedWin() / BetModel.totalBet);

                this.winThresholds.forEach((threshold) => {
                    if (profit >= threshold.winRatio) {
                        winSound = threshold.name;
                    };
                });

                if (SoundController.hasSound(GameSoundVars[winSound])) {
                    SoundController.playSound(GameSoundVars[winSound]);
                    ReelGroup.instance?.on(
                        GameEvents.ALL_REELS_STARTED,
                        () => {
                            SoundController.fadeStop(GameSoundVars[winSound], 0.5);
                            SoundController.fadeStop("win_loop", 0.5);
                        },
                        this);
                } else {
                    ConsoleUtil.warn("sound not found! ", GameSoundVars[winSound]);
                }

            } else {  // use standar win sound
                super.playWinSound();
            }
        }
    }
};
